<template>
    <div class="routerInfo">
  
      <div class="container-fluid container-panel container-mainblock">
        <div class="container">
          <div class="container-head">
            <div class="mainblock-left">
              <font-awesome-icon class="mainblock-icon" style="color: red" icon="newspaper" ></font-awesome-icon>
              <a  class="mainblock-label">成绩单</a>
            </div>
          </div>
          <div class="container-body panel-party" style="display: flex;flex-direction: column">
            
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <style rel='stylesheet/less' lang='less' scoped>
    @import "../../assets/less/variables.less";
    @import "../../assets/less/mySearch.less";
    @import "../../assets/less/style.less";
  </style>
  
  <script type="text/ecmascript-6">
    import viewFunction from "../../assets/js/viewFunction";
    const moment = require('moment')
    export default {
      data(){
        return {
          examId:'',
          examInfo: '',
          questionList: [],
          startTime:'',
          testTime: 0,
          testTimeTxt:'',
          examTime: 0,
          auto:{},
          onlineExamUserId: '',
          testStartTime: '',
          testEndTime: ''
        }
      },
      mounted() {
        this.onlineExamUserId = this.$route.query.onlineExamUserId
        this.findAllData()
      },
      methods:{
        findAllData(){
          
        },
      }
    }
  </script>
  


// WEBPACK FOOTER //
// src/views/learn/ExamDetail.vue